// extracted by mini-css-extract-plugin
export default {"mainTitle":"mainTitle_QuestionnaireChoices-module_ROotX","subtitle":"subtitle_QuestionnaireChoices-module_mulf8"};